import { Form } from "react-bootstrap";

const TextArea = ({
  formik = null,
  formClass = null,
  label = null,
  valueName,
  rows = 3,
  onClick = null,
  onKeyUp = null,
  onSelect = null,
  onChange = null,
  value: valueProp = undefined,
  labelStyle = { width: "100%", verticalAlign: "center" },
  LabelButton,
  namedReference = null,
  style = null,
}) => {
  return (
    <Form.Group
      className={formClass ? formClass : "form-inline"}
      controlId={valueName}
    >
      {label ? (
        <Form.Label style={labelStyle}>
          {label} {LabelButton && LabelButton()}
        </Form.Label>
      ) : null}
      <Form.Control
        placeholder={label}
        as="textarea"
        rows={rows ? rows : 3}
        name={valueName}
        value={valueProp !== undefined ? valueProp : formik?.values[valueName]}
        onChange={onChange || formik?.handleChange}
        isInvalid={!!formik?.errors[valueName]}
        style={{ width: "100%", ...(style || {}) }}
        onClick={(e) => { onClick && onClick(e); }}
        onKeyUp={(e) => { onKeyUp && onKeyUp(e); }}
        onSelect={(e) => { onSelect && onSelect(e); }}
        ref={namedReference}
      />
    </Form.Group>
  );
};

export default TextArea;
